export function convertJsonToObject(json) {
  const hasJson = !!json;
  if (hasJson) {
    try {
      const object = JSON.parse(json);
      const hasObject = !!object;
      if (hasObject) {
        return object;
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
      return null;
    }
  }
  return null;
}
